<template>
  <div class="profit-loss-reports reports main-content">
    <div class="page-header">
      <h3 class="page-title"> {{ $tc('data_exports.data_export', 2) }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/supplier/dashboard">
            {{ $t('general.home') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            slot="item-title"
            to="/supplier/data-exports/purchase-Orders">
            {{ $tc('data_exports.data_export', 2) }}
          </router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div class="col-xs-2">
          <base-button icon="download" size="large" color="theme" @click="onDownload()">
            {{ $t('data_exports.download_excel') }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <!-- Tabs -->
        <ul class="tabs">
          <li class="tab">
            <router-link class="tab-link" to="/supplier/data-exports/purchase-Orders">{{ $t('data_exports.purchase_orders.purchase_orders') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/supplier/data-exports/invoices">{{ $t('data_exports.invoices.invoice_summary') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/supplier/data-exports/invoice-detail">{{ $t('data_exports.invoices.invoice_detail') }}</router-link>
          </li>
          <li class="tab">
            <router-link class="tab-link" to="/supplier/data-exports/payments">{{ $t('data_exports.payments.payments') }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <transition
      name="fade"
      mode="out-in">
      <router-view ref="report"/>
    </transition>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";

export default {
  watch: {
    '$route.path' (newValue) {
      if (newValue === '/supplier/data-exports') {
        this.$router.push('/supplier/data-exports/purchase-Orders')
      }
    }
  },
  created () {
    if (this.$route.path === '/supplier/data-exports') {
      this.$router.push('/supplier/data-exports/purchase-Orders')
    }
    this.setInitialCompany()
  },
  computed: {
    ...mapGetters('company', {
      companies: 'getCompanies'
    }),
  },
  methods: {
    ...mapActions('company', ['setSelectedCompany']),
    onDownload () {
      this.$refs.report.downloadReport()
    },
    setInitialCompany () {
      let selectedCompany = Ls.get('selectedCompany') !== null

      if (selectedCompany) {
        let foundCompany = this.companies.find((company) => company.id === parseInt(selectedCompany))

        if (foundCompany) {
          this.setSelectedCompany(foundCompany)
          return
        }
      }

      this.setSelectedCompany(this.companies[0])
    }
  }

}
</script>

<style scoped>
.tab {
  padding: 0 !important;
}

.tab-link {
  padding: 10px 30px;
  display: block
}
</style>
